// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"dd297a1e","106":"83cb0819","162":"ecf14d93","301":"d8663ff6","394":"c759d7de","444":"50d1f81a","539":"3437736b","614":"dcd9b555","616":"8de4a6a3","715":"d2a07483","733":"2816b2d7","828":"ff21627b","987":"98944adb"}[chunkId] + ".chunk.js";
};